import { apmMonitor } from '@/service/apmMonitor';
import store from '@/store';
import { NOOP } from '@/utils';

export const unfoldError = ( msgIndex: string, timeout = 10000, icon = true, closeOperation: () => any = NOOP ): void => {

    store.dispatch( 'topInfoToggle', {

        type: 'error',
        msgIndex,
        timeout,
        icon,
        closeOperation

    }).catch( console.error );
    apmMonitor.setTransactionOutcome( 'failure' );

};

export const unfoldSuc = ( msgIndex: string, timeout = 5000 ): void => {

    store.dispatch( 'topInfoToggle', {

        type: 'success',
        msgIndex,
        timeout

    }).catch( console.error );

};

export const preSetErrorDetails = ( error: unknown ): void => {

    store.dispatch( 'topInfoToggle', {
        operation: async () => {

            await navigator.clipboard.writeText( JSON.stringify( error ));

        }
    }).catch( console.error );

};
